exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list .list__item{display:flex;align-items:flex-start}[dir] .list .list__item{padding:.4rem}", ""]);

// exports
